import { render, staticRenderFns } from "./DeleteStopButton.vue?vue&type=template&id=3345f08f&scoped=true&"
import script from "./DeleteStopButton.vue?vue&type=script&lang=js&"
export * from "./DeleteStopButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteStopButton.vue?vue&type=style&index=0&id=3345f08f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345f08f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3345f08f')) {
      api.createRecord('3345f08f', component.options)
    } else {
      api.reload('3345f08f', component.options)
    }
    module.hot.accept("./DeleteStopButton.vue?vue&type=template&id=3345f08f&scoped=true&", function () {
      api.rerender('3345f08f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Stops/buttons/DeleteStopButton.vue"
export default component.exports